import { render, staticRenderFns } from "./RoleConfigWindow.vue?vue&type=template&id=698a4e23&scoped=true&"
import script from "./RoleConfigWindow.vue?vue&type=script&lang=js&"
export * from "./RoleConfigWindow.vue?vue&type=script&lang=js&"
import style0 from "./RoleConfigWindow.vue?vue&type=style&index=0&id=698a4e23&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "698a4e23",
  null
  
)

export default component.exports